import { createContext, type ReactNode } from "react";

export type SiteMotionSettings = {
  cardAnimationsEnabled: boolean;
};

export const SiteMotionContext = createContext<SiteMotionSettings>({
  cardAnimationsEnabled: false,
});

export function SiteMotionProvider({
  cardAnimationsEnabled,
  children,
}: SiteMotionSettings & { children: ReactNode }) {
  return (
    <SiteMotionContext.Provider value={{ cardAnimationsEnabled }}>
      {children}
    </SiteMotionContext.Provider>
  );
}
